// extracted by mini-css-extract-plugin
export var callCard = "_k0-0";
export var callMessageButton = "_k0-1";
export var helpIcon = "_k0-3";
export var helpIconContainer = "_k0-4";
export var verticalDivider = "_k0-2";